import { createSlice } from '@reduxjs/toolkit';

const MAX_INDEX = 10;

const Slice = createSlice({
    name: 'dropdown',
    initialState: {
      showlists: Array.from({ length: MAX_INDEX }, () => false),
      selectedValues: [''],
      token: localStorage.getItem('token') || null,
    },
    reducers: {
      toggleDropdown: (state, action) => {
        const { index } = action.payload;
        // console.log('index', index)
        state.showlists = state.showlists.map((showlist, i) => (i === index ? !showlist : false));
      },
      setSelectedValue: (state, action) => {
        const { index, value } = action.payload;
        state.selectedValues[index] = value;
      },
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('token', action.payload); // Store token in localStorage
      },
    clearToken: (state) => {
      state.token = null;
      localStorage.removeItem('token'); // Remove token from localStorage
    },
  },
});

export const { toggleDropdown, setSelectedValue,setToken, clearToken } = Slice.actions;

export default Slice.reducer;
